var map = {
	"./2012-2014/Corso di Laurea/Architettura.json": 67,
	"./2012-2014/Corso di Laurea/Chimica_e_tecnologia_farmaceutiche.json": 68,
	"./2012-2014/Corso di Laurea/Direzione_aziendale.json": 69,
	"./2012-2014/Corso di Laurea/Economia.json": 70,
	"./2012-2014/Corso di Laurea/Economia_aziendale.json": 71,
	"./2012-2014/Corso di Laurea/Economia_e_gestione_delle_imprese_turistiche.json": 72,
	"./2012-2014/Corso di Laurea/Farmacia.json": 73,
	"./2012-2014/Corso di Laurea/Giurisprudenza.json": 74,
	"./2012-2014/Corso di Laurea/Informatica.json": 75,
	"./2012-2014/Corso di Laurea/Ingegneria_civile_e_ambientale.json": 76,
	"./2012-2014/Corso di Laurea/Ingegneria_edile-architettura.json": 77,
	"./2012-2014/Corso di Laurea/Ingegneria_elettronica.json": 78,
	"./2012-2014/Corso di Laurea/Ingegneria_industriale.json": 79,
	"./2012-2014/Corso di Laurea/Ingegneria_informatica.json": 80,
	"./2012-2014/Corso di Laurea/Mediazione_linguistica_e_interculturale.json": 81,
	"./2012-2014/Corso di Laurea/Medicina_e_chirurgia.json": 82,
	"./2012-2014/Corso di Laurea/Politica_e_relazioni_internazionali.json": 83,
	"./2012-2014/Corso di Laurea/Scienze_dell'amministrazione.json": 84,
	"./2012-2014/Corso di Laurea/Scienze_dell'educazione_e_della_formazione.json": 85,
	"./2012-2014/Corso di Laurea/Scienze_e_tecniche_psicologiche.json": 86,
	"./2012-2014/Corso di Laurea/Sociologia_e_servizio_sociale.json": 87,
	"./2012-2014/organi superiori/Comitato_per_lo_sport_universitario.json": 88,
	"./2012-2014/organi superiori/Consiglio_di_amministrazione.json": 89,
	"./2012-2014/organi superiori/Senato.json": 90,
	"./2013-2016/organi superiori/CNSU.json": 91,
	"./2014-2016/Corso di Laurea/Architettura.json": 92,
	"./2014-2016/Corso di Laurea/Beni_culturali.json": 93,
	"./2014-2016/Corso di Laurea/Chimica_e_tecnologia_farmaceutiche.json": 94,
	"./2014-2016/Corso di Laurea/Direzione_aziendale.json": 95,
	"./2014-2016/Corso di Laurea/Economia.json": 96,
	"./2014-2016/Corso di Laurea/Economia_aziendale.json": 97,
	"./2014-2016/Corso di Laurea/Economia_e_gestione_delle_imprese_turistiche.json": 98,
	"./2014-2016/Corso di Laurea/Farmacia.json": 99,
	"./2014-2016/Corso di Laurea/Giurisprudenza.json": 100,
	"./2014-2016/Corso di Laurea/Informatica.json": 101,
	"./2014-2016/Corso di Laurea/Ingegneria_civile_e_ambientale.json": 102,
	"./2014-2016/Corso di Laurea/Ingegneria_edile-architettura.json": 103,
	"./2014-2016/Corso di Laurea/Ingegneria_industriale.json": 104,
	"./2014-2016/Corso di Laurea/Ingegneria_informatica.json": 105,
	"./2014-2016/Corso di Laurea/Lettere.json": 106,
	"./2014-2016/Corso di Laurea/Lingue_e_culture_euroamericane_ed_orientali.json": 107,
	"./2014-2016/Corso di Laurea/Lingue_per_la_comunicazione_internazionale.json": 108,
	"./2014-2016/Corso di Laurea/Mediazione_linguistica_e_interculturale.json": 109,
	"./2014-2016/Corso di Laurea/Medicina_e_chirurgia.json": 110,
	"./2014-2016/Corso di Laurea/Scienze_biologiche.json": 111,
	"./2014-2016/Corso di Laurea/Scienze_dell'amministrazione.json": 112,
	"./2014-2016/Corso di Laurea/Scienze_dell'educazione_e_della_formazione.json": 113,
	"./2014-2016/Corso di Laurea/Scienze_e_lingue_per_la_comunicazione.json": 114,
	"./2014-2016/Corso di Laurea/Scienze_e_tecniche_psicologiche.json": 115,
	"./2014-2016/Corso di Laurea/Scienze_e_tecnologie_agrarie.json": 116,
	"./2014-2016/Corso di Laurea/Sociologia_e_servizio_sociale_-_percorso_in_servizi_sociali.json": 117,
	"./2014-2016/organi superiori/Comitato_per_lo_sport_universitario.json": 118,
	"./2014-2016/organi superiori/Consiglio_di_amministrazione.json": 119,
	"./2014-2016/organi superiori/Nucleo_di_valutazione.json": 120,
	"./2014-2016/organi superiori/Scuola_di_Medicina.json": 121,
	"./2014-2016/organi superiori/Senato.json": 122,
	"./2016-2018/Corso di Laurea <500/archeologia.json": 123,
	"./2016-2018/Corso di Laurea <500/biologia_ambientale.json": 124,
	"./2016-2018/Corso di Laurea <500/biologia_sanitaria_e_cellulare_e_molecolare.json": 125,
	"./2016-2018/Corso di Laurea <500/chemical_engineering_for_industrial_sustainability_development.json": 126,
	"./2016-2018/Corso di Laurea <500/chimica.json": 127,
	"./2016-2018/Corso di Laurea <500/chimica_biomolecolare.json": 128,
	"./2016-2018/Corso di Laurea <500/chimica_industriale.json": 129,
	"./2016-2018/Corso di Laurea <500/dietistica.json": 130,
	"./2016-2018/Corso di Laurea <500/economia_politiche_e_management_del_territorio.json": 131,
	"./2016-2018/Corso di Laurea <500/filologia_classica.json": 132,
	"./2016-2018/Corso di Laurea <500/filologia_moderna.json": 133,
	"./2016-2018/Corso di Laurea <500/filosofia.json": 134,
	"./2016-2018/Corso di Laurea <500/finanza_aziendale.json": 135,
	"./2016-2018/Corso di Laurea <500/fisica.json": 136,
	"./2016-2018/Corso di Laurea <500/fisica_magistrale.json": 137,
	"./2016-2018/Corso di Laurea <500/fisioterapia.json": 138,
	"./2016-2018/Corso di Laurea <500/global_politics_and_euro-mediterranean_relations.json": 139,
	"./2016-2018/Corso di Laurea <500/ingegneria_civile_delle_acque_e_dei_trasporti.json": 140,
	"./2016-2018/Corso di Laurea <500/ingegneria_civile_strutturale_e_geotecnica.json": 141,
	"./2016-2018/Corso di Laurea <500/ingegneria_dell'automazione_e_del_controllo_dei_sistemi_complessi.json": 142,
	"./2016-2018/Corso di Laurea <500/ingegneria_delle_telecomunicazioni.json": 143,
	"./2016-2018/Corso di Laurea <500/ingegneria_elettrica.json": 144,
	"./2016-2018/Corso di Laurea <500/ingegneria_elettronica.json": 145,
	"./2016-2018/Corso di Laurea <500/ingegneria_elettronica_magistrale.json": 146,
	"./2016-2018/Corso di Laurea <500/ingegneria_gestionale.json": 147,
	"./2016-2018/Corso di Laurea <500/ingegneria_meccanica.json": 148,
	"./2016-2018/Corso di Laurea <500/ingegneria_per_l'ambiente_e_il_territorio.json": 149,
	"./2016-2018/Corso di Laurea <500/internazionalizzazione_delle_relazioni_commerciali.json": 150,
	"./2016-2018/Corso di Laurea <500/lingue_e_culture_europee_ed_extraeuropee.json": 151,
	"./2016-2018/Corso di Laurea <500/lingue_e_letterature_comparate.json": 152,
	"./2016-2018/Corso di Laurea <500/lingue_per_la_cooperazione_internazionale.json": 153,
	"./2016-2018/Corso di Laurea <500/logopedia.json": 154,
	"./2016-2018/Corso di Laurea <500/matematica.json": 155,
	"./2016-2018/Corso di Laurea <500/matematica_magistrale.json": 156,
	"./2016-2018/Corso di Laurea <500/odontoiatria_e_protesi_dentaria.json": 157,
	"./2016-2018/Corso di Laurea <500/ortottica_ed_assistenza_oftalmologica.json": 158,
	"./2016-2018/Corso di Laurea <500/ostetricia.json": 159,
	"./2016-2018/Corso di Laurea <500/pianificazione_e_tutela_del_territorio_e_del_paesaggio.json": 160,
	"./2016-2018/Corso di Laurea <500/programmazione_e_gestione_delle_politiche_e_dei_servizi_sociali.json": 161,
	"./2016-2018/Corso di Laurea <500/psicologia.json": 162,
	"./2016-2018/Corso di Laurea <500/salvaguardia_del_territorio_dell'ambiente_e_del_paesaggio.json": 163,
	"./2016-2018/Corso di Laurea <500/scienze_ambientali_e_naturali.json": 164,
	"./2016-2018/Corso di Laurea <500/scienze_delle_pubbliche_amministrazioni.json": 165,
	"./2016-2018/Corso di Laurea <500/scienze_dello_spettacolo_e_comunicazione_multimediale.json": 166,
	"./2016-2018/Corso di Laurea <500/scienze_e_tecnologie_agrarie.json": 167,
	"./2016-2018/Corso di Laurea <500/scienze_e_tecnologie_alimentari.json": 168,
	"./2016-2018/Corso di Laurea <500/scienze_filosofiche.json": 169,
	"./2016-2018/Corso di Laurea <500/scienze_geofisiche.json": 170,
	"./2016-2018/Corso di Laurea <500/scienze_geologiche.json": 171,
	"./2016-2018/Corso di Laurea <500/scienze_geologiche_magistrale.json": 172,
	"./2016-2018/Corso di Laurea <500/scienze_infermieristiche_ed_ostetriche.json": 173,
	"./2016-2018/Corso di Laurea <500/scienze_motorie.json": 174,
	"./2016-2018/Corso di Laurea <500/scienze_pedagogiche_e_progettazione_educativa.json": 175,
	"./2016-2018/Corso di Laurea <500/scienze_riabilitative_delle_professioni_sanitarie.json": 176,
	"./2016-2018/Corso di Laurea <500/sociologia.json": 177,
	"./2016-2018/Corso di Laurea <500/storia_dell'arte_e_beni_culturali.json": 178,
	"./2016-2018/Corso di Laurea <500/tecnica_della_riabilitazione_psichiatrica.json": 179,
	"./2016-2018/Corso di Laurea <500/tecniche_audioprotesiche.json": 180,
	"./2016-2018/Corso di Laurea <500/tecniche_di_fisiopatologia_cardiocircolatoria_e_perfusione_.json": 181,
	"./2016-2018/Corso di Laurea <500/tecniche_di_laboratorio_biomedico.json": 182,
	"./2016-2018/Corso di Laurea <500/tecniche_di_radiologia_medica_per_immagini_e_radioterapia.json": 183,
	"./2016-2018/Corso di Laurea/Architettura.json": 184,
	"./2016-2018/Corso di Laurea/Beni_culturali.json": 185,
	"./2016-2018/Corso di Laurea/Chimica_e_tecnologia_farmaceutiche.json": 186,
	"./2016-2018/Corso di Laurea/Direzione_aziendale.json": 187,
	"./2016-2018/Corso di Laurea/Economia.json": 188,
	"./2016-2018/Corso di Laurea/Economia_aziendale.json": 189,
	"./2016-2018/Corso di Laurea/Farmacia.json": 190,
	"./2016-2018/Corso di Laurea/Formazione_di_operatori_turistici.json": 191,
	"./2016-2018/Corso di Laurea/Giurisprudenza.json": 192,
	"./2016-2018/Corso di Laurea/Infermieristica.json": 193,
	"./2016-2018/Corso di Laurea/Informatica.json": 194,
	"./2016-2018/Corso di Laurea/Ingegneria_civile_e_ambientale.json": 195,
	"./2016-2018/Corso di Laurea/Ingegneria_edile-architettura.json": 196,
	"./2016-2018/Corso di Laurea/Ingegneria_industriale.json": 197,
	"./2016-2018/Corso di Laurea/Ingegneria_informatica.json": 198,
	"./2016-2018/Corso di Laurea/Lettere.json": 199,
	"./2016-2018/Corso di Laurea/Lingue_e_culture_euroamericane_ed_orientali.json": 200,
	"./2016-2018/Corso di Laurea/Lingue_per_la_comunicazione_internazionale.json": 201,
	"./2016-2018/Corso di Laurea/Mediazione_linguistica_e_interculturale.json": 202,
	"./2016-2018/Corso di Laurea/Medicina_e_chirurgia.json": 203,
	"./2016-2018/Corso di Laurea/Scienze_biologiche.json": 204,
	"./2016-2018/Corso di Laurea/Scienze_dell'amministrazione.json": 205,
	"./2016-2018/Corso di Laurea/Scienze_dell'educazione_e_della_formazione.json": 206,
	"./2016-2018/Corso di Laurea/Scienze_e_tecniche_psicologiche.json": 207,
	"./2016-2018/Corso di Laurea/Scienze_e_tecnologie_agrarie.json": 208,
	"./2016-2018/Corso di Laurea/Scienze_e_tecnologie_alimentari.json": 209,
	"./2016-2018/Corso di Laurea/Scienze_farmaceutiche_applicate.json": 210,
	"./2016-2018/Corso di Laurea/Sociologia_e_servizio_sociale_-_percorso_in_servizi_sociali.json": 211,
	"./2016-2018/Corso di Laurea/Storia_politica_e_relazioni_internazionali.json": 212,
	"./2016-2018/Dipartimento [Dottorandi]/Scienze_biologiche_geologiche_e_ambientali.json": 213,
	"./2016-2018/Dipartimento [Dottorandi]/Scienze_chimiche.json": 214,
	"./2016-2018/Dipartimento/Agricoltura_alimentazione_e_ambiente.json": 215,
	"./2016-2018/Dipartimento/Chirurgia_generale_e_specialità_medico_chirurgiche.json": 216,
	"./2016-2018/Dipartimento/Economia_e_impresa.json": 217,
	"./2016-2018/Dipartimento/Fisica_e_astronomia.json": 218,
	"./2016-2018/Dipartimento/Giurisprudenza.json": 219,
	"./2016-2018/Dipartimento/Ingegneria_civile_e_architettura.json": 220,
	"./2016-2018/Dipartimento/Ingegneria_elettrica_elettronica_e_informatica.json": 221,
	"./2016-2018/Dipartimento/Matematica_e_informatica.json": 222,
	"./2016-2018/Dipartimento/Medicina_clinica_e_sperimentale.json": 223,
	"./2016-2018/Dipartimento/Scienze_biologiche_geologiche_e_ambientali.json": 224,
	"./2016-2018/Dipartimento/Scienze_biomediche_e_biotecnologiche.json": 225,
	"./2016-2018/Dipartimento/Scienze_chimiche.json": 226,
	"./2016-2018/Dipartimento/Scienze_del_farmaco.json": 227,
	"./2016-2018/Dipartimento/Scienze_della_formazione.json": 228,
	"./2016-2018/Dipartimento/Scienze_mediche_chirurgiche_tecn_avanzate_GF_Ingrassia.json": 229,
	"./2016-2018/Dipartimento/Scienze_politiche_e_sociali.json": 230,
	"./2016-2018/Dipartimento/Scienze_umanistiche.json": 231,
	"./2016-2018/Dipartimento/Struttura_didattica_speciale_di_architettura.json": 232,
	"./2016-2018/Dipartimento/Struttura_didattica_speciale_di_lingue_e_letterature_straniere.json": 233,
	"./2016-2018/organi superiori/Comitato_per_lo_sport_universitario.json": 234,
	"./2016-2018/organi superiori/Consiglio_di_amministrazione.json": 235,
	"./2016-2018/organi superiori/Nucleo_di_valutazione.json": 236,
	"./2016-2018/organi superiori/Scuola_di_Medicina.json": 237,
	"./2016-2018/organi superiori/Senato.json": 238,
	"./2016-2018/seggi.json": 239,
	"./2016-2019/organi superiori/CNSU.json": 240,
	"./2018-2020/Corso di Laurea <500/archeologia.json": 241,
	"./2018-2020/Corso di Laurea <500/biologia_sanitaria_e_cellulare-molecolare.json": 242,
	"./2018-2020/Corso di Laurea <500/biotecnologie_agrarie.json": 243,
	"./2018-2020/Corso di Laurea <500/biotecnologie_mediche.json": 244,
	"./2018-2020/Corso di Laurea <500/chemical_engineering_for_industrial_sustainability_development.json": 245,
	"./2018-2020/Corso di Laurea <500/chimica.json": 246,
	"./2018-2020/Corso di Laurea <500/chimica_biomolecolare.json": 247,
	"./2018-2020/Corso di Laurea <500/chimica_dei_materiali.json": 248,
	"./2018-2020/Corso di Laurea <500/chimica_industriale.json": 249,
	"./2018-2020/Corso di Laurea <500/chimica_organica_e_biorganica.json": 250,
	"./2018-2020/Corso di Laurea <500/comunicazione_della_cultura_e_dello_spettacolo.json": 251,
	"./2018-2020/Corso di Laurea <500/dietistica.json": 252,
	"./2018-2020/Corso di Laurea <500/economia_politiche_e_management_del_territorio.json": 253,
	"./2018-2020/Corso di Laurea <500/electrical_engineering.json": 254,
	"./2018-2020/Corso di Laurea <500/filologia_classica.json": 255,
	"./2018-2020/Corso di Laurea <500/filologia_moderna.json": 256,
	"./2018-2020/Corso di Laurea <500/filosofia.json": 257,
	"./2018-2020/Corso di Laurea <500/finanza_aziendale.json": 258,
	"./2018-2020/Corso di Laurea <500/fisica.json": 259,
	"./2018-2020/Corso di Laurea <500/fisioterapia.json": 260,
	"./2018-2020/Corso di Laurea <500/formazione_di_operatori_turistici.json": 261,
	"./2018-2020/Corso di Laurea <500/global_politics_and_euro-mediterranean_relations.json": 262,
	"./2018-2020/Corso di Laurea <500/informatica_magistrale.json": 263,
	"./2018-2020/Corso di Laurea <500/ingegneria_civile_delle_acque_e_dei_trasporti.json": 264,
	"./2018-2020/Corso di Laurea <500/ingegneria_civile_strutturale_e_geotecnica.json": 265,
	"./2018-2020/Corso di Laurea <500/ingegneria_dell'automazione_e_del_controllo_dei_sistemi_complessi.json": 266,
	"./2018-2020/Corso di Laurea <500/ingegneria_gestionale.json": 267,
	"./2018-2020/Corso di Laurea <500/ingegneria_informatica.json": 268,
	"./2018-2020/Corso di Laurea <500/ingegneria_meccanica.json": 269,
	"./2018-2020/Corso di Laurea <500/internazionalizzazione_delle_relazioni_commerciali.json": 270,
	"./2018-2020/Corso di Laurea <500/lingue_e_culture_europee_ed_extraeuropee.json": 271,
	"./2018-2020/Corso di Laurea <500/lingue_e_letterature_comparate.json": 272,
	"./2018-2020/Corso di Laurea <500/lingue_per_la_cooperazione_internazionale.json": 273,
	"./2018-2020/Corso di Laurea <500/logopedia.json": 274,
	"./2018-2020/Corso di Laurea <500/management_della_pubblica_amministrazione.json": 275,
	"./2018-2020/Corso di Laurea <500/matematica.json": 276,
	"./2018-2020/Corso di Laurea <500/matematica_magistrale.json": 277,
	"./2018-2020/Corso di Laurea <500/odontoiatria_e_protesi_dentaria.json": 278,
	"./2018-2020/Corso di Laurea <500/ortottica_ed_assistenza_oftalmologica.json": 279,
	"./2018-2020/Corso di Laurea <500/ostetricia.json": 280,
	"./2018-2020/Corso di Laurea <500/physics.json": 281,
	"./2018-2020/Corso di Laurea <500/pianificazione_e_tutela_del_territorio_e_del_paesaggio.json": 282,
	"./2018-2020/Corso di Laurea <500/politiche_e_servizi_sociali.json": 283,
	"./2018-2020/Corso di Laurea <500/psicologia.json": 284,
	"./2018-2020/Corso di Laurea <500/salvaguardia_del_territorio_dell'ambiente_e_del_paesaggio.json": 285,
	"./2018-2020/Corso di Laurea <500/scienze_ambientali_e_naturali.json": 286,
	"./2018-2020/Corso di Laurea <500/scienze_e_tecn.delle_attivita'_motorie_preventive.json": 287,
	"./2018-2020/Corso di Laurea <500/scienze_e_tecnologie_agrarie.json": 288,
	"./2018-2020/Corso di Laurea <500/scienze_e_tecnologie_alimentari.json": 289,
	"./2018-2020/Corso di Laurea <500/scienze_farmaceutiche_applicate.json": 290,
	"./2018-2020/Corso di Laurea <500/scienze_filosofiche.json": 291,
	"./2018-2020/Corso di Laurea <500/scienze_geofisiche.json": 292,
	"./2018-2020/Corso di Laurea <500/scienze_geologiche_laurea_magistrale.json": 293,
	"./2018-2020/Corso di Laurea <500/scienze_geologiche_laurea_triennale.json": 294,
	"./2018-2020/Corso di Laurea <500/scienze_infermieristiche_ed_ostetriche.json": 295,
	"./2018-2020/Corso di Laurea <500/scienze_motorie.json": 296,
	"./2018-2020/Corso di Laurea <500/scienze_pedagogiche_e_progettazione_educativa.json": 297,
	"./2018-2020/Corso di Laurea <500/scienze_riabilitative_delle_professioni_sanitarie.json": 298,
	"./2018-2020/Corso di Laurea <500/sociologia_delle_reti_dell'_informazione_e_dell'_innovazione.json": 299,
	"./2018-2020/Corso di Laurea <500/storia_dell'arte_e_beni_culturali.json": 300,
	"./2018-2020/Corso di Laurea <500/storia_e_cultura_dei_paesi_mediterranei.json": 301,
	"./2018-2020/Corso di Laurea <500/tecnica_della_riabilitazione_psichiatrica.json": 302,
	"./2018-2020/Corso di Laurea <500/tecniche_audioprotesiche.json": 303,
	"./2018-2020/Corso di Laurea <500/tecniche_di_fisiopatologia_cardiocircolatoria_e_perfusione_c.json": 304,
	"./2018-2020/Corso di Laurea <500/tecniche_di_laboratorio_biomedico.json": 305,
	"./2018-2020/Corso di Laurea <500/tecniche_di_radiologia_medica_per_immagini_e_radioterapia.json": 306,
	"./2018-2020/Corso di Laurea/Architettura.json": 307,
	"./2018-2020/Corso di Laurea/Beni_culturali.json": 308,
	"./2018-2020/Corso di Laurea/Chimica_e_tecnologia_farmaceutiche.json": 309,
	"./2018-2020/Corso di Laurea/Direzione_aziendale.json": 310,
	"./2018-2020/Corso di Laurea/Economia.json": 311,
	"./2018-2020/Corso di Laurea/Economia_aziendale.json": 312,
	"./2018-2020/Corso di Laurea/Farmacia.json": 313,
	"./2018-2020/Corso di Laurea/Giurisprudenza.json": 314,
	"./2018-2020/Corso di Laurea/Infermieristica.json": 315,
	"./2018-2020/Corso di Laurea/Informatica.json": 316,
	"./2018-2020/Corso di Laurea/Ingegneria_civile_e_ambientale.json": 317,
	"./2018-2020/Corso di Laurea/Ingegneria_edile-architettura.json": 318,
	"./2018-2020/Corso di Laurea/Ingegneria_elettronica.json": 319,
	"./2018-2020/Corso di Laurea/Ingegneria_industriale.json": 320,
	"./2018-2020/Corso di Laurea/Ingegneria_informatica.json": 321,
	"./2018-2020/Corso di Laurea/Lettere.json": 322,
	"./2018-2020/Corso di Laurea/Lingue_e_culture_euroamericane_e_orientali.json": 323,
	"./2018-2020/Corso di Laurea/Mediazione_linguistica_e_interculturale.json": 324,
	"./2018-2020/Corso di Laurea/Medicina_e_chirurgia.json": 325,
	"./2018-2020/Corso di Laurea/Scienze_biologiche.json": 326,
	"./2018-2020/Corso di Laurea/Scienze_dell'amministrazione.json": 327,
	"./2018-2020/Corso di Laurea/Scienze_dell'educazione_e_della_formazione.json": 328,
	"./2018-2020/Corso di Laurea/Scienze_e_lingue_per_la_comunicazione.json": 329,
	"./2018-2020/Corso di Laurea/Scienze_e_tecniche_psicologiche.json": 330,
	"./2018-2020/Corso di Laurea/Scienze_e_tecnologie_agrarie.json": 331,
	"./2018-2020/Corso di Laurea/Scienze_e_tecnologie_alimentari.json": 332,
	"./2018-2020/Corso di Laurea/Sociologia_e_servizio_sociale.json": 333,
	"./2018-2020/Corso di Laurea/Storia_politica_e_relazioni_internazionali.json": 334,
	"./2018-2020/Dipartimento [Dottorandi]/Agricoltura_alimentazione_e_ambiente.json": 335,
	"./2018-2020/Dipartimento [Dottorandi]/Fisica_e_astronomia.json": 336,
	"./2018-2020/Dipartimento [Dottorandi]/Giurisprudenza.json": 337,
	"./2018-2020/Dipartimento [Dottorandi]/Ingegneria_civile_e_architettura.json": 338,
	"./2018-2020/Dipartimento [Dottorandi]/Ingegneria_elettrica_elettronica_e_informatica.json": 339,
	"./2018-2020/Dipartimento [Dottorandi]/Matematica_e_informatica.json": 340,
	"./2018-2020/Dipartimento [Dottorandi]/Medicina_clinica_e_sperimentale.json": 341,
	"./2018-2020/Dipartimento [Dottorandi]/Scienze_biologiche_geologiche_e_ambientali.json": 342,
	"./2018-2020/Dipartimento [Dottorandi]/Scienze_chimiche.json": 343,
	"./2018-2020/Dipartimento [Dottorandi]/Scienze_umanistiche.json": 344,
	"./2018-2020/Dipartimento/Agricoltura_alimentazione_e_ambiente.json": 345,
	"./2018-2020/Dipartimento/Chirurgia_generale_e_specialità_medico_chirurgiche.json": 346,
	"./2018-2020/Dipartimento/Economia_e_impresa.json": 347,
	"./2018-2020/Dipartimento/Fisica_e_astronomia.json": 348,
	"./2018-2020/Dipartimento/Giurisprudenza.json": 349,
	"./2018-2020/Dipartimento/Ingegneria_civile_e_architettura.json": 350,
	"./2018-2020/Dipartimento/Ingegneria_elettrica_elettronica_e_informatica.json": 351,
	"./2018-2020/Dipartimento/Matematica_e_informatica.json": 352,
	"./2018-2020/Dipartimento/Medicina_clinica_e_sperimentale.json": 353,
	"./2018-2020/Dipartimento/Scienze_biologiche_geologiche_e_ambientali.json": 354,
	"./2018-2020/Dipartimento/Scienze_biomediche_e_biotecnologiche.json": 355,
	"./2018-2020/Dipartimento/Scienze_chimiche.json": 356,
	"./2018-2020/Dipartimento/Scienze_del_farmaco.json": 357,
	"./2018-2020/Dipartimento/Scienze_della_formazione.json": 358,
	"./2018-2020/Dipartimento/Scienze_mediche_chirurgiche_tecn_avanzate_GF_Ingrassia.json": 359,
	"./2018-2020/Dipartimento/Scienze_politiche_e_sociali.json": 360,
	"./2018-2020/Dipartimento/Scienze_umanistiche.json": 361,
	"./2018-2020/Dipartimento/Struttura_didattica_speciale_di_architettura.json": 362,
	"./2018-2020/Dipartimento/Struttura_didattica_speciale_di_lingue_e_letterature_straniere.json": 363,
	"./2018-2020/organi superiori/Comitato_per_lo_sport_universitario.json": 364,
	"./2018-2020/organi superiori/Consiglio_di_amministrazione.json": 365,
	"./2018-2020/organi superiori/Nucleo_di_valutazione.json": 366,
	"./2018-2020/organi superiori/Scuola_di_Medicina.json": 367,
	"./2018-2020/organi superiori/Senato.json": 368,
	"./2018-2020/seggi.json": 369,
	"./2019-2023/organi superiori/CNSU.json": 370,
	"./2019-2023/organi superiori/ERSU.json": 371,
	"./2021-2023/Corso di Laurea <500/archeologia.json": 372,
	"./2021-2023/Corso di Laurea <500/automation_engineering_and_control_of_complex_systems.json": 373,
	"./2021-2023/Corso di Laurea <500/biologia_ambientale.json": 374,
	"./2021-2023/Corso di Laurea <500/biologia_sanitaria_e_cellulare-molecolare.json": 375,
	"./2021-2023/Corso di Laurea <500/biotecnologie.json": 376,
	"./2021-2023/Corso di Laurea <500/biotecnologie_agrarie.json": 377,
	"./2021-2023/Corso di Laurea <500/biotecnologie_mediche.json": 378,
	"./2021-2023/Corso di Laurea <500/chemical_engineering_for_industrial_sustainability_development.json": 379,
	"./2021-2023/Corso di Laurea <500/chimica.json": 380,
	"./2021-2023/Corso di Laurea <500/chimica_industriale.json": 381,
	"./2021-2023/Corso di Laurea <500/comunicazione_della_cultura_e_dello_spettacolo.json": 382,
	"./2021-2023/Corso di Laurea <500/data_science_for_management.json": 383,
	"./2021-2023/Corso di Laurea <500/dietistica.json": 384,
	"./2021-2023/Corso di Laurea <500/economia_e_management_del_territorio_e_del_turismo.json": 385,
	"./2021-2023/Corso di Laurea <500/electrical_engineering.json": 386,
	"./2021-2023/Corso di Laurea <500/electronic_engineering.json": 387,
	"./2021-2023/Corso di Laurea <500/filologia_classica.json": 388,
	"./2021-2023/Corso di Laurea <500/filologia_moderna.json": 389,
	"./2021-2023/Corso di Laurea <500/filosofia.json": 390,
	"./2021-2023/Corso di Laurea <500/finanza_aziendale.json": 391,
	"./2021-2023/Corso di Laurea <500/fisica.json": 392,
	"./2021-2023/Corso di Laurea <500/fisioterapia.json": 393,
	"./2021-2023/Corso di Laurea <500/global_politics_and_euro-mediterranean_relations.json": 394,
	"./2021-2023/Corso di Laurea <500/informatica_magistrale.json": 395,
	"./2021-2023/Corso di Laurea <500/ingegneria_civile_delle_acque_e_dei_trasporti.json": 396,
	"./2021-2023/Corso di Laurea <500/ingegneria_civile_strutturale_e_geotecnica.json": 397,
	"./2021-2023/Corso di Laurea <500/ingegneria_delle_telecomunicazioni.json": 398,
	"./2021-2023/Corso di Laurea <500/ingegneria_gestionale.json": 399,
	"./2021-2023/Corso di Laurea <500/ingegneria_informatica.json": 400,
	"./2021-2023/Corso di Laurea <500/ingegneria_meccanica.json": 401,
	"./2021-2023/Corso di Laurea <500/ingegneria_per_l'ambiente_e_il_territorio.json": 402,
	"./2021-2023/Corso di Laurea <500/internazionalizzazione_delle_relazioni_commerciali.json": 403,
	"./2021-2023/Corso di Laurea <500/lingue_e_letterature_comparate.json": 404,
	"./2021-2023/Corso di Laurea <500/lingue_per_la_cooperazione_internazionale.json": 405,
	"./2021-2023/Corso di Laurea <500/logopedia.json": 406,
	"./2021-2023/Corso di Laurea <500/management_della_pubblica_amministrazione.json": 407,
	"./2021-2023/Corso di Laurea <500/matematica.json": 408,
	"./2021-2023/Corso di Laurea <500/odontoiatria_e_protesi_dentaria.json": 409,
	"./2021-2023/Corso di Laurea <500/ortottica_ed_assistenza_oftalmologica.json": 410,
	"./2021-2023/Corso di Laurea <500/ostetricia.json": 411,
	"./2021-2023/Corso di Laurea <500/physics.json": 412,
	"./2021-2023/Corso di Laurea <500/pianificazione_e_tutela_del_territorio_e_del_paesaggio.json": 413,
	"./2021-2023/Corso di Laurea <500/politiche_e_servizi_sociali.json": 414,
	"./2021-2023/Corso di Laurea <500/psicologia.json": 415,
	"./2021-2023/Corso di Laurea <500/salvaguardia_del_territorio_dell'ambiente_e_del_paesaggio.json": 416,
	"./2021-2023/Corso di Laurea <500/scienze_ambientali_e_naturali.json": 417,
	"./2021-2023/Corso di Laurea <500/scienze_chimiche.json": 418,
	"./2021-2023/Corso di Laurea <500/scienze_del_turismo.json": 419,
	"./2021-2023/Corso di Laurea <500/scienze_e_tecniche_delle_attività_motorie_preventive_e_adattate.json": 420,
	"./2021-2023/Corso di Laurea <500/scienze_e_tecnologie_agrarie.json": 421,
	"./2021-2023/Corso di Laurea <500/scienze_e_tecnologie_alimentari.json": 422,
	"./2021-2023/Corso di Laurea <500/scienze_farmaceutiche_applicate.json": 423,
	"./2021-2023/Corso di Laurea <500/scienze_geofisiche.json": 424,
	"./2021-2023/Corso di Laurea <500/scienze_geologiche_laurea_magistrale.json": 425,
	"./2021-2023/Corso di Laurea <500/scienze_geologiche_laurea_triennale.json": 426,
	"./2021-2023/Corso di Laurea <500/scienze_infermieristiche_ed_ostetriche.json": 427,
	"./2021-2023/Corso di Laurea <500/scienze_linguistiche_per_l'intercultura_e_la_formazione.json": 428,
	"./2021-2023/Corso di Laurea <500/scienze_motorie.json": 429,
	"./2021-2023/Corso di Laurea <500/scienze_pedagogiche_e_progettazione_educativa.json": 430,
	"./2021-2023/Corso di Laurea <500/scienze_riabilitative_delle_professioni_sanitarie.json": 431,
	"./2021-2023/Corso di Laurea <500/sociologia_delle_reti_dell'_informazione_e_dell'_innovazione.json": 432,
	"./2021-2023/Corso di Laurea <500/storia_dell'arte_e_beni_culturali.json": 433,
	"./2021-2023/Corso di Laurea <500/storia_e_cultura_dei_paesi_mediterranei.json": 434,
	"./2021-2023/Corso di Laurea <500/tecnica_della_riabilitazione_psichiatrica.json": 435,
	"./2021-2023/Corso di Laurea <500/tecniche_audioprotesiche.json": 436,
	"./2021-2023/Corso di Laurea <500/tecniche_di_fisiopatologia_cardiocircolatoria_e_perfusione_c.json": 437,
	"./2021-2023/Corso di Laurea <500/tecniche_di_laboratorio_biomedico.json": 438,
	"./2021-2023/Corso di Laurea <500/tecniche_di_radiologia_medica_per_immagini_e_radioterapia.json": 439,
	"./2021-2023/Corso di Laurea <500/terapia_occupazionale.json": 440,
	"./2021-2023/Corso di Laurea/Architettura.json": 441,
	"./2021-2023/Corso di Laurea/Beni_culturali.json": 442,
	"./2021-2023/Corso di Laurea/Chimica_e_tecnologia_farmaceutiche.json": 443,
	"./2021-2023/Corso di Laurea/Direzione_aziendale.json": 444,
	"./2021-2023/Corso di Laurea/Economia.json": 445,
	"./2021-2023/Corso di Laurea/Economia_aziendale.json": 446,
	"./2021-2023/Corso di Laurea/Farmacia.json": 447,
	"./2021-2023/Corso di Laurea/Giurisprudenza.json": 448,
	"./2021-2023/Corso di Laurea/Infermieristica.json": 449,
	"./2021-2023/Corso di Laurea/Informatica.json": 450,
	"./2021-2023/Corso di Laurea/Ingegneria_civile_e_ambientale.json": 451,
	"./2021-2023/Corso di Laurea/Ingegneria_edile-architettura.json": 452,
	"./2021-2023/Corso di Laurea/Ingegneria_elettronica.json": 453,
	"./2021-2023/Corso di Laurea/Ingegneria_industriale.json": 454,
	"./2021-2023/Corso di Laurea/Ingegneria_informatica.json": 455,
	"./2021-2023/Corso di Laurea/Lettere.json": 456,
	"./2021-2023/Corso di Laurea/Lingue_e_culture_euroamericane_e_orientali.json": 457,
	"./2021-2023/Corso di Laurea/Mediazione_linguistica_e_interculturale.json": 458,
	"./2021-2023/Corso di Laurea/Medicina_e_chirurgia.json": 459,
	"./2021-2023/Corso di Laurea/Politica_e_relazioni_internazionali.json": 460,
	"./2021-2023/Corso di Laurea/Scienze_biologiche.json": 461,
	"./2021-2023/Corso di Laurea/Scienze_dell'amministrazione.json": 462,
	"./2021-2023/Corso di Laurea/Scienze_dell'educazione_e_della_formazione.json": 463,
	"./2021-2023/Corso di Laurea/Scienze_e_lingue_per_la_comunicazione.json": 464,
	"./2021-2023/Corso di Laurea/Scienze_e_tecniche_psicologiche.json": 465,
	"./2021-2023/Corso di Laurea/Scienze_e_tecnologie_agrarie.json": 466,
	"./2021-2023/Corso di Laurea/Scienze_e_tecnologie_alimentari.json": 467,
	"./2021-2023/Corso di Laurea/Sociologia_e_servizio_sociale.json": 468,
	"./2021-2023/Dipartimento [Dottorandi]/Agricoltura_alimentazione_e_ambiente.json": 469,
	"./2021-2023/Dipartimento [Dottorandi]/Fisica_e_astronomia.json": 470,
	"./2021-2023/Dipartimento [Dottorandi]/Giurisprudenza.json": 471,
	"./2021-2023/Dipartimento [Dottorandi]/Ingegneria_civile_e_architettura.json": 472,
	"./2021-2023/Dipartimento [Dottorandi]/Ingegneria_elettrica_elettronica_e_informatica.json": 473,
	"./2021-2023/Dipartimento [Dottorandi]/Matematica_e_informatica.json": 474,
	"./2021-2023/Dipartimento [Dottorandi]/Medicina_clinica_e_sperimentale.json": 475,
	"./2021-2023/Dipartimento [Dottorandi]/Scienze_biologiche_geologiche_e_ambientali.json": 476,
	"./2021-2023/Dipartimento [Dottorandi]/Scienze_biomediche_e_biotecnologiche.json": 477,
	"./2021-2023/Dipartimento [Dottorandi]/Scienze_chimiche.json": 478,
	"./2021-2023/Dipartimento [Dottorandi]/Scienze_della_formazione.json": 479,
	"./2021-2023/Dipartimento [Dottorandi]/Scienze_politiche_e_sociali.json": 480,
	"./2021-2023/Dipartimento [Dottorandi]/Scienze_umanistiche.json": 481,
	"./2021-2023/Dipartimento/Agricoltura_alimentazione_e_ambiente.json": 482,
	"./2021-2023/Dipartimento/Chirurgia_generale_e_specialità_medico_chirurgiche.json": 483,
	"./2021-2023/Dipartimento/Economia_e_impresa.json": 484,
	"./2021-2023/Dipartimento/Fisica_e_astronomia.json": 485,
	"./2021-2023/Dipartimento/Giurisprudenza.json": 486,
	"./2021-2023/Dipartimento/Ingegneria_civile_e_architettura.json": 487,
	"./2021-2023/Dipartimento/Ingegneria_elettrica_elettronica_e_informatica.json": 488,
	"./2021-2023/Dipartimento/Matematica_e_informatica.json": 489,
	"./2021-2023/Dipartimento/Medicina_clinica_e_sperimentale.json": 490,
	"./2021-2023/Dipartimento/Scienze_biologiche_geologiche_e_ambientali.json": 491,
	"./2021-2023/Dipartimento/Scienze_biomediche_e_biotecnologiche.json": 492,
	"./2021-2023/Dipartimento/Scienze_chimiche.json": 493,
	"./2021-2023/Dipartimento/Scienze_del_farmaco.json": 494,
	"./2021-2023/Dipartimento/Scienze_della_formazione.json": 495,
	"./2021-2023/Dipartimento/Scienze_mediche_chirurgiche_tecn_avanzate_GF_Ingrassia.json": 496,
	"./2021-2023/Dipartimento/Scienze_politiche_e_sociali.json": 497,
	"./2021-2023/Dipartimento/Scienze_umanistiche.json": 498,
	"./2021-2023/Dipartimento/Struttura_didattica_speciale_di_architettura.json": 499,
	"./2021-2023/Dipartimento/Struttura_didattica_speciale_di_lingue_e_letterature_straniere.json": 500,
	"./2021-2023/organi superiori/Comitato_per_lo_sport_universitario.json": 501,
	"./2021-2023/organi superiori/Consiglio_di_amministrazione.json": 502,
	"./2021-2023/organi superiori/Nucleo_di_valutazione.json": 503,
	"./2021-2023/organi superiori/Scuola_di_Medicina.json": 504,
	"./2021-2023/organi superiori/Senato.json": 505,
	"./2023-2025/Corso di Laurea <500/archeologia.json": 506,
	"./2023-2025/Corso di Laurea <500/architettura.json": 507,
	"./2023-2025/Corso di Laurea <500/automation_engineering_and_control_of_complex_systems.json": 508,
	"./2023-2025/Corso di Laurea <500/biologia_ambientale.json": 509,
	"./2023-2025/Corso di Laurea <500/biologia_sperimentale_e_applicata.json": 510,
	"./2023-2025/Corso di Laurea <500/biotecnologie.json": 511,
	"./2023-2025/Corso di Laurea <500/chimica.json": 512,
	"./2023-2025/Corso di Laurea <500/chimica_industriale.json": 513,
	"./2023-2025/Corso di Laurea <500/communications_engineering.json": 514,
	"./2023-2025/Corso di Laurea <500/comunicazione_della_cultura_e_dello_spettacolo.json": 515,
	"./2023-2025/Corso di Laurea <500/data_science.json": 516,
	"./2023-2025/Corso di Laurea <500/dietistica.json": 517,
	"./2023-2025/Corso di Laurea <500/direzione_aziendale.json": 518,
	"./2023-2025/Corso di Laurea <500/economia_e_management_del_territorio_e_del_turismo.json": 519,
	"./2023-2025/Corso di Laurea <500/electrical_engineering_for_sustainable_green_energy_transition.json": 520,
	"./2023-2025/Corso di Laurea <500/filologia_classica.json": 521,
	"./2023-2025/Corso di Laurea <500/filologia_moderna.json": 522,
	"./2023-2025/Corso di Laurea <500/filosofia.json": 523,
	"./2023-2025/Corso di Laurea <500/finanza_aziendale.json": 524,
	"./2023-2025/Corso di Laurea <500/fisica.json": 525,
	"./2023-2025/Corso di Laurea <500/fisioterapia.json": 526,
	"./2023-2025/Corso di Laurea <500/global_politics_and_euro.json": 527,
	"./2023-2025/Corso di Laurea <500/informatica_magistrale.json": 528,
	"./2023-2025/Corso di Laurea <500/ingegneria_civile_delle_acque_e_dei_trasporti.json": 529,
	"./2023-2025/Corso di Laurea <500/ingegneria_civile_strutturale_e_geotecnica.json": 530,
	"./2023-2025/Corso di Laurea <500/ingegneria_elettronica.json": 531,
	"./2023-2025/Corso di Laurea <500/ingegneria_gestionale.json": 532,
	"./2023-2025/Corso di Laurea <500/ingegneria_informatica.json": 533,
	"./2023-2025/Corso di Laurea <500/ingegneria_meccanica.json": 534,
	"./2023-2025/Corso di Laurea <500/ingegneria_per_l'ambiente_e_il_territorio.json": 535,
	"./2023-2025/Corso di Laurea <500/lingue_e_letterature_comparate.json": 536,
	"./2023-2025/Corso di Laurea <500/lingue_per_la_cooperazione_internazionale.json": 537,
	"./2023-2025/Corso di Laurea <500/logopedia.json": 538,
	"./2023-2025/Corso di Laurea <500/management_delle_imprese_per_l'economia_sostenibile.json": 539,
	"./2023-2025/Corso di Laurea <500/matematica.json": 540,
	"./2023-2025/Corso di Laurea <500/matematica_magistrale.json": 541,
	"./2023-2025/Corso di Laurea <500/odontoiatria_e_protesi_dentaria.json": 542,
	"./2023-2025/Corso di Laurea <500/ortottica_ed_assistenza_oftalmologica.json": 543,
	"./2023-2025/Corso di Laurea <500/ostetricia.json": 544,
	"./2023-2025/Corso di Laurea <500/physics.json": 545,
	"./2023-2025/Corso di Laurea <500/pianificazione_e_sostenibilità_ambientale_del_territorio_e_del_paesaggio.json": 546,
	"./2023-2025/Corso di Laurea <500/politiche_e_servizi_sociali.json": 547,
	"./2023-2025/Corso di Laurea <500/psicologia.json": 548,
	"./2023-2025/Corso di Laurea <500/scienze_ambientali_e_naturali.json": 549,
	"./2023-2025/Corso di Laurea <500/scienze_chimiche.json": 550,
	"./2023-2025/Corso di Laurea <500/scienze_del_testo_per_le_professioni_digitali.json": 551,
	"./2023-2025/Corso di Laurea <500/scienze_del_turismo.json": 552,
	"./2023-2025/Corso di Laurea <500/scienze_della_nutrizione_umana.json": 553,
	"./2023-2025/Corso di Laurea <500/scienze_e_tecniche_delle_attività_motorie_preventive_e_adattate.json": 554,
	"./2023-2025/Corso di Laurea <500/scienze_e_tecnologie_agrarie.json": 555,
	"./2023-2025/Corso di Laurea <500/scienze_e_tecnologie_alimentari.json": 556,
	"./2023-2025/Corso di Laurea <500/scienze_e_tecnologie_per_la_ristorazione_e_distribuzione_degli_alimenti_mediterranei.json": 557,
	"./2023-2025/Corso di Laurea <500/scienze_farmaceutiche_applicate.json": 558,
	"./2023-2025/Corso di Laurea <500/scienze_filosofiche.json": 559,
	"./2023-2025/Corso di Laurea <500/scienze_geofisiche.json": 560,
	"./2023-2025/Corso di Laurea <500/scienze_geologiche.json": 561,
	"./2023-2025/Corso di Laurea <500/scienze_infermieristiche_ed_ostetriche.json": 562,
	"./2023-2025/Corso di Laurea <500/scienze_linguistiche_per_l'intercultura_e_la_formazione.json": 563,
	"./2023-2025/Corso di Laurea <500/scienze_pedagogiche_e_progettazione_educativa.json": 564,
	"./2023-2025/Corso di Laurea <500/scienze_riabilitative_delle_professioni_sanitarie.json": 565,
	"./2023-2025/Corso di Laurea <500/storia_dell'arte_e_beni_culturali.json": 566,
	"./2023-2025/Corso di Laurea <500/storia_e_cultura_dei_paesi_mediterranei.json": 567,
	"./2023-2025/Corso di Laurea <500/tecnica_della_riabilitazione_psichiatrica.json": 568,
	"./2023-2025/Corso di Laurea <500/tecniche_audioprotesiche.json": 569,
	"./2023-2025/Corso di Laurea/Beni_culturali.json": 570,
	"./2023-2025/Corso di Laurea/Chimica_e_tecnologia_farmaceutiche.json": 571,
	"./2023-2025/Corso di Laurea/Economia.json": 572,
	"./2023-2025/Corso di Laurea/Economia_aziendale.json": 573,
	"./2023-2025/Corso di Laurea/Farmacia.json": 574,
	"./2023-2025/Corso di Laurea/Giurisprudenza.json": 575,
	"./2023-2025/Corso di Laurea/Infermieristica.json": 576,
	"./2023-2025/Corso di Laurea/Informatica.json": 577,
	"./2023-2025/Corso di Laurea/Ingegneria_civile_e_ambientale.json": 578,
	"./2023-2025/Corso di Laurea/Ingegneria_industriale.json": 579,
	"./2023-2025/Corso di Laurea/Ingegneria_informatica.json": 580,
	"./2023-2025/Corso di Laurea/Lettere.json": 581,
	"./2023-2025/Corso di Laurea/Lingue_e_culture_euroamericane_e_orientali.json": 582,
	"./2023-2025/Corso di Laurea/Mediazione_linguistica_e_interculturale.json": 583,
	"./2023-2025/Corso di Laurea/Medicina_e_chirurgia.json": 584,
	"./2023-2025/Corso di Laurea/Scienze_biologiche.json": 585,
	"./2023-2025/Corso di Laurea/Scienze_dell'amministrazione.json": 586,
	"./2023-2025/Corso di Laurea/Scienze_dell'educazione_e_della_formazione.json": 587,
	"./2023-2025/Corso di Laurea/Scienze_e_lingue_per_la_comunicazione.json": 588,
	"./2023-2025/Corso di Laurea/Scienze_e_tecniche_psicologiche.json": 589,
	"./2023-2025/Corso di Laurea/Scienze_e_tecnologie_agrarie.json": 590,
	"./2023-2025/Corso di Laurea/Scienze_motorie.json": 591,
	"./2023-2025/Corso di Laurea/Sociologia_e_servizio_sociale.json": 592,
	"./2023-2025/Corso di Laurea/Storia_politica_e_relazioni_internazionali.json": 593,
	"./2023-2025/Dipartimento [Dottorandi]/Agricoltura_alimentazione_e_ambiente.json": 594,
	"./2023-2025/Dipartimento [Dottorandi]/Economia_e_impresa.json": 595,
	"./2023-2025/Dipartimento [Dottorandi]/Fisica_e_astronomia.json": 596,
	"./2023-2025/Dipartimento [Dottorandi]/Giurisprudenza.json": 597,
	"./2023-2025/Dipartimento [Dottorandi]/Ingegneria_civile_e_architettura.json": 598,
	"./2023-2025/Dipartimento [Dottorandi]/Ingegneria_elettrica_elettronica_e_informatica.json": 599,
	"./2023-2025/Dipartimento [Dottorandi]/Matematica_e_informatica.json": 600,
	"./2023-2025/Dipartimento [Dottorandi]/Medicina_clinica_e_sperimentale.json": 601,
	"./2023-2025/Dipartimento [Dottorandi]/Scienze_biologiche_geologiche_e_ambientali.json": 602,
	"./2023-2025/Dipartimento [Dottorandi]/Scienze_biomediche_e_biotecnologiche.json": 603,
	"./2023-2025/Dipartimento [Dottorandi]/Scienze_chimiche.json": 604,
	"./2023-2025/Dipartimento [Dottorandi]/Scienze_della_formazione.json": 605,
	"./2023-2025/Dipartimento [Dottorandi]/Scienze_politiche_e_sociali.json": 606,
	"./2023-2025/Dipartimento [Dottorandi]/Scienze_umanistiche.json": 607,
	"./2023-2025/Dipartimento/Agricoltura_alimentazione_e_ambiente.json": 608,
	"./2023-2025/Dipartimento/Chirurgia_generale_e_specialità_medico_chirurgiche.json": 609,
	"./2023-2025/Dipartimento/Economia_e_impresa.json": 610,
	"./2023-2025/Dipartimento/Fisica_e_astronomia.json": 611,
	"./2023-2025/Dipartimento/Giurisprudenza.json": 612,
	"./2023-2025/Dipartimento/Ingegneria_civile_e_architettura.json": 613,
	"./2023-2025/Dipartimento/Ingegneria_elettrica_elettronica_e_informatica.json": 614,
	"./2023-2025/Dipartimento/Matematica_e_informatica.json": 615,
	"./2023-2025/Dipartimento/Medicina_clinica_e_sperimentale.json": 616,
	"./2023-2025/Dipartimento/Scienze_biologiche_geologiche_e_ambientali.json": 617,
	"./2023-2025/Dipartimento/Scienze_biomediche_e_biotecnologiche.json": 618,
	"./2023-2025/Dipartimento/Scienze_chimiche.json": 619,
	"./2023-2025/Dipartimento/Scienze_del_farmaco.json": 620,
	"./2023-2025/Dipartimento/Scienze_della_formazione.json": 621,
	"./2023-2025/Dipartimento/Scienze_mediche_chirurgiche_tecn_avanzate_GF_Ingrassia.json": 622,
	"./2023-2025/Dipartimento/Scienze_politiche_e_sociali.json": 623,
	"./2023-2025/Dipartimento/Scienze_umanistiche.json": 624,
	"./2023-2025/organi superiori/CNSU.json": 625,
	"./2023-2025/organi superiori/Comitato_per_lo_sport_universitario.json": 626,
	"./2023-2025/organi superiori/Consiglio_di_amministrazione.json": 627,
	"./2023-2025/organi superiori/ERSU.json": 628,
	"./2023-2025/organi superiori/Nucleo_di_valutazione.json": 629,
	"./2023-2025/organi superiori/Scuola_di_Medicina.json": 630,
	"./2023-2025/organi superiori/Senato.json": 631,
	"./2025-2027/Corso di Laurea <500/agricoltural_science_and_tecnology.json": 632,
	"./2025-2027/Corso di Laurea <500/archeologia.json": 633,
	"./2025-2027/Corso di Laurea <500/architettura.json": 634,
	"./2025-2027/Corso di Laurea <500/automation_engineering_and_control_of_complex_systems.json": 635,
	"./2025-2027/Corso di Laurea <500/biologia_ambientale.json": 636,
	"./2025-2027/Corso di Laurea <500/biologia_sperimentale_e_applicata.json": 637,
	"./2025-2027/Corso di Laurea <500/biotecnologie_agrarie.json": 638,
	"./2025-2027/Corso di Laurea <500/biotecnologie_mediche.json": 639,
	"./2025-2027/Corso di Laurea <500/chemical_engineering_for_industrial_sustainability.json": 640,
	"./2025-2027/Corso di Laurea <500/chimica.json": 641,
	"./2025-2027/Corso di Laurea <500/chimica_industriale.json": 642,
	"./2025-2027/Corso di Laurea <500/communications_engineering.json": 643,
	"./2025-2027/Corso di Laurea <500/data_science.json": 644,
	"./2025-2027/Corso di Laurea <500/dietistica.json": 645,
	"./2025-2027/Corso di Laurea <500/direzione_aziendale.json": 646,
	"./2025-2027/Corso di Laurea <500/economia_e_politiche_pubbliche.json": 647,
	"./2025-2027/Corso di Laurea <500/electronic_engineering.json": 648,
	"./2025-2027/Corso di Laurea <500/filologia_classica.json": 649,
	"./2025-2027/Corso di Laurea <500/filologia_moderna.json": 650,
	"./2025-2027/Corso di Laurea <500/filosofia.json": 651,
	"./2025-2027/Corso di Laurea <500/finanza_aziendale.json": 652,
	"./2025-2027/Corso di Laurea <500/fisica.json": 653,
	"./2025-2027/Corso di Laurea <500/fisioterapia.json": 654,
	"./2025-2027/Corso di Laurea <500/geologia_e_geofisica.json": 655,
	"./2025-2027/Corso di Laurea <500/gestione_dei_sistemi_produttivi_agrari_mediterranei.json": 656,
	"./2025-2027/Corso di Laurea <500/gestione_sostenibile_dellambiente_e_del_paesaggio.json": 657,
	"./2025-2027/Corso di Laurea <500/global_politics_and_euro.json": 658,
	"./2025-2027/Corso di Laurea <500/informatica_magistrale.json": 659,
	"./2025-2027/Corso di Laurea <500/ingegneria_civile_delle_acque_e_dei_trasporti.json": 660,
	"./2025-2027/Corso di Laurea <500/ingegneria_civile_strutturale_e_geotecnica.json": 661,
	"./2025-2027/Corso di Laurea <500/ingegneria_edile-architettura.json": 662,
	"./2025-2027/Corso di Laurea <500/ingegneria_elettronica.json": 663,
	"./2025-2027/Corso di Laurea <500/ingegneria_gestionale.json": 664,
	"./2025-2027/Corso di Laurea <500/ingegneria_gestionale_triennale.json": 665,
	"./2025-2027/Corso di Laurea <500/ingegneria_informatica.json": 666,
	"./2025-2027/Corso di Laurea <500/ingegneria_meccanica.json": 667,
	"./2025-2027/Corso di Laurea <500/ingegneria_per_l'ambiente_e_il_territorio.json": 668,
	"./2025-2027/Corso di Laurea <500/ingegneria_per_la_transizione_ecologica.json": 669,
	"./2025-2027/Corso di Laurea <500/logopedia.json": 670,
	"./2025-2027/Corso di Laurea <500/management_della_pubblica_amministrazione.json": 671,
	"./2025-2027/Corso di Laurea <500/management_delle_imprese_per_l’economia_sostenibile.json": 672,
	"./2025-2027/Corso di Laurea <500/matematica.json": 673,
	"./2025-2027/Corso di Laurea <500/matematica_magistrale.json": 674,
	"./2025-2027/Corso di Laurea <500/mediazione_linguistica_e_interculturale.json": 675,
	"./2025-2027/Corso di Laurea <500/medicine_and_surgery.json": 676,
	"./2025-2027/Corso di Laurea <500/odontoiatria_e_protesi_dentaria.json": 677,
	"./2025-2027/Corso di Laurea <500/ortottica_ed_assistenza_oftalmologica.json": 678,
	"./2025-2027/Corso di Laurea <500/ostetricia.json": 679,
	"./2025-2027/Corso di Laurea <500/physics.json": 680,
	"./2025-2027/Corso di Laurea <500/pianificazione_e_sostenibilità_ambientale_del_territorio_e_del_paesaggio.json": 681,
	"./2025-2027/Corso di Laurea <500/politiche_e_servizi_sociali.json": 682,
	"./2025-2027/Corso di Laurea <500/progettazione_del_turismo_sostenibile_culturale_e_naturalistico.json": 683,
	"./2025-2027/Corso di Laurea <500/relazioni_internazionali.json": 684,
	"./2025-2027/Corso di Laurea <500/scienze_ambientali_e_naturali.json": 685,
	"./2025-2027/Corso di Laurea <500/scienze_chimiche.json": 686,
	"./2025-2027/Corso di Laurea <500/scienze_del_testo_per_le_professioni_digitali.json": 687,
	"./2025-2027/Corso di Laurea <500/scienze_della_formazione_primaria.json": 688,
	"./2025-2027/Corso di Laurea <500/scienze_e_tecnologie_agrarie.json": 689,
	"./2025-2027/Corso di Laurea <500/scienze_e_tecnologie_alimentari.json": 690,
	"./2025-2027/Corso di Laurea <500/scienze_e_tecnologie_alimentari_magistrale.json": 691,
	"./2025-2027/Corso di Laurea <500/scienze_e_tecnologie_per_la_ristorazione_e_distribuzione_degli_alimenti_mediterranei.json": 692,
	"./2025-2027/Corso di Laurea <500/scienze_farmaceutiche_applicate.json": 693,
	"./2025-2027/Corso di Laurea <500/scienze_geologiche.json": 694,
	"./2025-2027/Corso di Laurea <500/scienze_linguistiche_per_l'intercultura_e_la_formazione.json": 695,
	"./2025-2027/Corso di Laurea <500/scienze_pedagogiche_e_progettazione_educativa.json": 696,
	"./2025-2027/Corso di Laurea <500/sociologia_delle_reti_dell_informazione_e_dell_innovazione.json": 697,
	"./2025-2027/Corso di Laurea <500/storia_e_cultura_dei_paesi_mediterranei.json": 698,
	"./2025-2027/Corso di Laurea <500/tecnica_della_riabilitazione_psichiatrica.json": 699,
	"./2025-2027/Corso di Laurea <500/tecniche_della_prevenzione_nellambiente_e_nei_luoghi_di_lavoro.json": 700,
	"./2025-2027/Corso di Laurea <500/tecniche_di_fisiopatologia_cardiocircolatoria_e_perfusione_cardiovascolare.json": 701,
	"./2025-2027/Corso di Laurea <500/tecniche_di_laboratorio_biomedico.json": 702,
	"./2025-2027/Corso di Laurea <500/tecniche_di_radiologia_medica_per_immagini_e_radioterapia.json": 703,
	"./2025-2027/Corso di Laurea/Biotecnologie.json": 704,
	"./2025-2027/Corso di Laurea/Chimica_e_tecnologia_farmaceutiche.json": 705,
	"./2025-2027/Corso di Laurea/Economia.json": 706,
	"./2025-2027/Corso di Laurea/Economia_aziendale.json": 707,
	"./2025-2027/Corso di Laurea/Farmacia.json": 708,
	"./2025-2027/Corso di Laurea/Giurisprudenza.json": 709,
	"./2025-2027/Corso di Laurea/Infermieristica.json": 710,
	"./2025-2027/Corso di Laurea/Informatica.json": 711,
	"./2025-2027/Corso di Laurea/Ingegneria_civile_ambientale_e_gestionale.json": 712,
	"./2025-2027/Corso di Laurea/Ingegneria_industriale.json": 713,
	"./2025-2027/Corso di Laurea/Ingegneria_informatica.json": 714,
	"./2025-2027/Corso di Laurea/Lettere.json": 715,
	"./2025-2027/Corso di Laurea/Lingue_e_culture_euroamericane_e_orientali.json": 716,
	"./2025-2027/Corso di Laurea/Medicina_e_chirurgia.json": 717,
	"./2025-2027/Corso di Laurea/Scienze_biologiche.json": 718,
	"./2025-2027/Corso di Laurea/Scienze_dell'amministrazione.json": 719,
	"./2025-2027/Corso di Laurea/Scienze_dell'educazione_e_della_formazione.json": 720,
	"./2025-2027/Corso di Laurea/Scienze_e_lingue_per_la_comunicazione.json": 721,
	"./2025-2027/Corso di Laurea/Scienze_e_tecniche_psicologiche.json": 722,
	"./2025-2027/Corso di Laurea/Scienze_e_tecnologie_agrarie.json": 723,
	"./2025-2027/Corso di Laurea/Scienze_motorie.json": 724,
	"./2025-2027/Corso di Laurea/Sociologia_e_servizio_sociale.json": 725,
	"./2025-2027/Corso di Laurea/Storia_politica_e_relazioni_internazionali.json": 726,
	"./2025-2027/Dipartimento [Dottorandi]/Agricoltura_alimentazione_e_ambiente.json": 727,
	"./2025-2027/Dipartimento [Dottorandi]/Economia_e_impresa.json": 728,
	"./2025-2027/Dipartimento [Dottorandi]/Fisica_e_astronomia.json": 729,
	"./2025-2027/Dipartimento [Dottorandi]/Giurisprudenza.json": 730,
	"./2025-2027/Dipartimento [Dottorandi]/Ingegneria_civile_e_architettura.json": 731,
	"./2025-2027/Dipartimento [Dottorandi]/Matematica_e_informatica.json": 732,
	"./2025-2027/Dipartimento [Dottorandi]/Scienze_biologiche_geologiche_e_ambientali.json": 733,
	"./2025-2027/Dipartimento [Dottorandi]/Scienze_chimiche.json": 734,
	"./2025-2027/Dipartimento [Dottorandi]/Scienze_della_formazione.json": 735,
	"./2025-2027/Dipartimento [Dottorandi]/Scienze_politiche_e_sociali.json": 736,
	"./2025-2027/Dipartimento [Dottorandi]/Scienze_umanistiche.json": 737,
	"./2025-2027/Dipartimento/Agricoltura_alimentazione_e_ambiente.json": 738,
	"./2025-2027/Dipartimento/Chirurgia_generale_e_specialità_medico_chirurgiche.json": 739,
	"./2025-2027/Dipartimento/Economia_e_impresa.json": 740,
	"./2025-2027/Dipartimento/Fisica_e_astronomia.json": 741,
	"./2025-2027/Dipartimento/Giurisprudenza.json": 742,
	"./2025-2027/Dipartimento/Ingegneria_civile_e_architettura.json": 743,
	"./2025-2027/Dipartimento/Ingegneria_elettrica_elettronica_e_informatica.json": 744,
	"./2025-2027/Dipartimento/Matematica_e_informatica.json": 745,
	"./2025-2027/Dipartimento/Medicina_clinica_e_sperimentale.json": 746,
	"./2025-2027/Dipartimento/Scienze_biologiche_geologiche_e_ambientali.json": 747,
	"./2025-2027/Dipartimento/Scienze_biomediche_e_biotecnologiche.json": 748,
	"./2025-2027/Dipartimento/Scienze_chimiche.json": 749,
	"./2025-2027/Dipartimento/Scienze_del_farmaco.json": 750,
	"./2025-2027/Dipartimento/Scienze_della_formazione.json": 751,
	"./2025-2027/Dipartimento/Scienze_mediche_chirurgiche_tecn_avanzate_GF_Ingrassia.json": 752,
	"./2025-2027/Dipartimento/Scienze_politiche_e_sociali.json": 753,
	"./2025-2027/Dipartimento/Scienze_umanistiche.json": 754,
	"./2025-2027/organi superiori/Comitato_per_lo_sport_universitario.json": 755,
	"./2025-2027/organi superiori/Consiglio_di_amministrazione.json": 756,
	"./2025-2027/organi superiori/Nucleo_di_valutazione.json": 757,
	"./2025-2027/organi superiori/Scuola_di_Medicina.json": 758,
	"./2025-2027/organi superiori/Senato.json": 759,
	"./2025-2028/organi superiori/CNSU.json": 760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 786;